var $e71526efc6cad0df$exports = {};
$e71526efc6cad0df$exports = {
    "more": `\u{66F4}\u{591A}\u{9805}\u{76EE}`
};


export {$e71526efc6cad0df$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
